// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4298":"beebe9ac","5538":"bd5972b9","6749":"5c745074","9910":"beebe9ac"}[chunkId] + ".chunk.css";
};